import { render } from "./Relationorder.vue?vue&type=template&id=7387484c&scoped=true"
import script from "./Relationorder.vue?vue&type=script&lang=js"
export * from "./Relationorder.vue?vue&type=script&lang=js"

import "./Relationorder.vue?vue&type=style&index=0&id=7387484c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7387484c"

export default script